module.exports = __webpack_public_path__ + "static/media/yeezylogo-white.7e5d3f27.svg";